module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-x-back-d479f3494a1689c7be76aea817fce295.svg";